import React, { useEffect, useState } from "react";
import {
  Button,
  TableContainer,
  Paper,
  Box,
  CircularProgress,
} from "@mui/material";
import { initialUserData } from "../../types/User";
import { createData, deleteData } from "../../api/PatientsApi";
import {
  createData as createUser,
  deleteData as deleteUsser,
  getUsersForPendingTask,
  updateData as updateUser,
} from "../../api/UsersApi";

import { AddCircleSharp } from "@mui/icons-material";
import { UserData } from "../../types/User";

import { toast } from "react-toastify";
import { showConfirmation } from "../../utils/SwalHelper";
import { hasModuleActionPermission } from "../../utils/RolePermissions";
import {
  AppActionEnum,
  ModuleEnum,
  transactionEnum,
} from "../../utils/AppEnum";
import { GenericTable } from "../../components/common/GenericTable";
import { getPendingTaskIds } from "../../api/WorkflowApi";
import { personTableColumns } from "../patients/tables/TableHeader";

const OPDList: React.FC = () => {
  const [query, setQuery] = useState<string>("");

  const [form, setForm] = useState<UserData>();
  const [listData, setListData] = useState<UserData[]>([]);
  const [userIds, setUserIds] = useState<number[]>([]);
  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(true); // <-- loading state
  const [viewDetail, setViewDetail] = useState(false);

  const loadData = async () => {
    setLoading(true);

    const pendingId = await getPendingTaskIds(transactionEnum.OPD);
    setUserIds(pendingId);

    setLoading(false);
  };

  const loadUserData = async () => {
    if (userIds.length > 0) {
      setLoading(true);
      const data = await getUsersForPendingTask(userIds);
      setListData(data);
      setLoading(false);

      setLoading(false);
    }
  };

  const handleAdd = () => {
    setIsEdit(false);
    setForm(initialUserData);
    setOpen(true);
  };

  const handleDetail = async (data: UserData) => {
    setViewDetail(true);
  };
  const handleEdit = async (data: UserData) => {
    setIsEdit(true);

    setOpen(true);
  };

  const handleOnReset = async () => {
    setQuery("");
    setListData([]);
  };

  const handleBack = () => {
    setViewDetail(false);
  };

  const handleDelete = async (id: number) => {
    try {
      const confirmed = await showConfirmation(
        "Are you sure?",
        "Do you want to delete this record permanently?",
        "warning",
        "Yes, delete it!"
      );

      if (confirmed) {
        const respUser = await deleteUsser(id);
        if (!respUser) {
          toast.error("Failed to delete record");
          return;
        }
        const respPerson = await deleteData(id);
        if (respPerson) {
          toast.success("Record deleted successfully");
          await loadData(); // reload table after delete
        }
      }
    } catch (error: any) {
      console.error("Delete failed:", error);
      toast.error(error.response?.data?.message || "Error deleting record");
    }
  };

  const onSubmit = async (data: Partial<UserData>) => {
    setIsEdit(false);

    if (data?.id) {
      const resp = await updateUser(data.id, data);
      if (resp == null) {
        toast.error("Update failed.");
        return;
      }

      toast.success("Record successfully updated.");
    } else {
      const roleId = 2;
      const resp = await createUser(data);

      if (resp == null) {
        toast.error("Failed to create record");
        return;
      }

      const respData = await createData(data);
      if (respData == null) {
        await deleteUsser(resp.id);
        toast.error("Failed to create record");
      } else {
        toast.success("Record successfully created.");
      }
    }
    setOpen(false);
    loadData();
  };

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    loadUserData();
  }, [userIds]);

  return (
    <div>
      {!viewDetail && (
        <Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" }, // column on mobile
              alignItems: { xs: "stretch", md: "center" },
              gap: 2,
              width: "100%",
            }}
          >
            {/* GenericSearch */}

            {/* Add Button */}
            {hasModuleActionPermission(
              ModuleEnum.Registration,
              AppActionEnum.Create
            ) && (
              <Box sx={{ flex: { xs: "0 0 100%", md: "0 0 8%" } }}>
                <Button
                  fullWidth
                  startIcon={<AddCircleSharp />}
                  onClick={handleAdd}
                  variant="contained"
                  color="success"
                >
                  Add
                </Button>
              </Box>
            )}
          </Box>

          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
              <CircularProgress />
            </Box>
          ) : (
            <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
              <GenericTable
                data={listData}
                columns={personTableColumns}
                actions={{
                  view: (row) => handleDetail(row),
                }}
              />
            </TableContainer>
          )}
        </Box>
      )}
      {viewDetail && (
        <Box>
          {/* <PersonDetail
            detailData={form || initialUserData}
            handleBack={handleBack}
            registeredIds={registeredIds}
          /> */}
        </Box>
      )}
    </div>
  );
};

export default OPDList;
